
























import { Component, Vue, Watch } from "vue-property-decorator";
import RestaurantModule from "@/store/restaurant";
import OrderModule from "@/store/order";
import { Menu, OrderDetail } from "@/api/api";
import { truncate } from "@/utils/Util";

@Component
export default class RestaurantMenuList extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private menuWithCounters: any = [];

  private get menus() {
    return RestaurantModule.menus;
  }

  @Watch("menus")
  private mergeCounter(menus: Menu[]) {
    this.menuWithCounters = menus.map(menu => {
      return { ...menu, amount: 1 };
    });
  }

  private mounted() {
    // this.menuWithCounters = this.menus;
    this.mergeCounter(this.menus);
  }

  private truncateName(name: string) {
    const len = 18;
    return truncate(name, len);
  }

  private addCart(menu: Menu & { amount: number; isAddedCart?: boolean }) {
    const orderDetail = {
      menuUuid: menu.uuid,
      quantity: menu.amount,
      menu,
    } as OrderDetail;

    OrderModule.commitAddOrderDetail({
      restaurantUuid: menu.restaurantUuid,
      orderDetail,
    });
    this.mergeCounter(this.menus);
    // eslint-disable-next-line no-param-reassign
    OrderModule.commitIsAddedCart(true);
    setTimeout(() => {
      // eslint-disable-next-line no-param-reassign
      OrderModule.commitIsAddedCart(false);
    }, 3000);
  }
}
